<template>
	<div>
		<loading :active="loading">
			<img :src="$env.ROOT + '/img/loading.gif'" width="55px" height="55px">
		</loading>
		<div class="row">
			<div class="col-md-6">
				<div class="checkbox checkbox-success" v-if="!upload">
					<input type="checkbox" v-model="product.display_images">
					<label for="checkbox0"> Mostrar todas </label>
				</div>
			</div>
			<div class="col-md-6">
				<button @click="upload=!upload" type="button" class="btn btn-default pull-right">
					<template v-if="!upload">
						<i class="fa fa-plus" aria-hidden="true"></i>
						Añadir imágenes
					</template>
					<template v-else>
						<i class="fa fa-arrow-left" aria-hidden="true"></i>
						Volver
					</template>
				</button>
			</div>
		</div>
		<hr>
		<div class="row">
			<template v-if="upload">
				<div class="col-md-12">
					<dropzone
						:id="'dropzone' + new Date().getTime()"
						ref="dropzone"
						:use-font-awesome="true"
						:url="dropzone.url"
						:accepted-file-types="dropzone.accepted"
						:maxFileSizeInMB="dropzone.maxFileSizeInMB"
						:maxNumberOfFiles="dropzone.maxNumberOfFiles"
						:thumbnail-height="100"
						:thumbnail-width="100"
						:headers="dropzone.headers"
						v-on:vdropzone-success="dropzoneSuccess">
					</dropzone>
				</div>
			</template>
			<template v-else>
				<template v-for="media in product.media">
					<div class="col-md-2">
						<img
							@click="select(media)"
							:src="media.path"
							class="img-responsive link"
							:class="{ 'img-selected img-thumbnail' : media.selected || product.display_images }">
						<button @click="destroy(media)" type="button" class="btn btn-danger btn-block">
							<i class="fa fa-trash" aria-hidden="true"></i>
						</button>
					</div>
				</template>
			</template>
		</div>
	</div>
</template>
<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'
	import VueElementLoading from 'vue-element-loading'
	import Dropzone from 'vue2-dropzone'

	export default {
		props: ['user', 'isAuth', 'product'],
		components: {
			'loading': VueElementLoading,
			'dropzone': Dropzone,
		},
		data () {
			return {
				modal: {
					selector: 'modal-images-' + Math.floor(Math.random() * 736456),
				},

				loading: false,

				upload: false,

				data: [],

				dropzone: {
					headers: {
						'Authorization': 'Bearer ' + this.$auth.getToken(),
						'account': this.$platform.slug,
					},
					accepted: this.$env.ACCEPTED_DROPZONE_IMAGES,
					url: process.env.ROOT + '/api/' + this.$lang.getLang() + '/admin/management/products/storages/' + this.product.id + '/add/images',
					maxFileSizeInMB: 20,
					maxNumberOfFiles: 10,
				},
			}
		},
		watch: {
			'product.display_images'() {
				this.selectAll()
			},
		},
		mounted() {
			this.initArray()
			this.renderImages()
		},
		methods: {
			reload() {
				this.$emit('reload')
			},
			initArray() {
				if(this.product.display_images) {
					if(!this.product.images_to_display) {
						this.product.images_to_display = []
					}
					if(this.product.media) {
						if(this.product.media.length) {
							var that = this
							this.product.media.forEach(function(media) {
								that.product.images_to_display.push(media.id)
								that.$set(media, 'selected', true)
							})
						}
					}
				}
			},
			select(media) {
				media.selected = !media.selected
				if(media.selected) {
					if(!this.product.images_to_display) {
						this.product.images_to_display = []
					}
					this.product.images_to_display.push(media.id)
				} else {
						let index = this.product.images_to_display.indexOf(media.id)
						if(index >= 0) {
							this.product.images_to_display.splice(index, 1)
						} else {
							if(this.product.media) {
								if(this.product.media.length) {
									var found = this.product.media.filter(function(element) {
										return element.id != media.id
									})
									if(found) {
										if(found.length) {
											var that = this
											found.forEach(function(element) {
												that.product.images_to_display.push(element.id)
											})
										}
									}
								}
							}
						}
				}
				if(this.product.images_to_display.length == this.product.media.length) {
					this.product.display_images = true
				} else {
					this.product.display_images = false
				}
			},
			selectAll() {
				if(this.product.display_images) {
					this.product.images_to_display = []
					/*
					var that = this
					if(this.product.media) {
						if(this.product.media.length) {
							this.product.media.forEach(function(media) {
								that.product.images_to_display.push(media.id)
								that.$set(media, 'selected', true)
							})
						}
					}
					*/
				} else {
					if(this.product.images_to_display.length == this.product.media.length) {
						this.product.images_to_display = []
					}
				}
				this.renderImages()
			},
			renderImages() {
				if(this.product) {
					if(this.product.media) {
						if(this.product.media.length) {
							//-- Display all images
							var that = this
							if(this.product.display_images) {
								this.product.media.forEach(function(media) {
									that.$set(media, 'selected', true)
								})
							} else {
								if(this.product.images_to_display) {
									this.product.media.forEach(function(media) {
										var found = that.product.images_to_display.find(function(id) {
											return id == media.id
										})
										if(found) {
											that.$set(media, 'selected', true)
										} else {
											that.$set(media, 'selected', false)
										}
									})
								} else {
									this.product.media.forEach(function(media) {
										that.$set(media, 'selected', false)
									})
								}
							}
						}
					}
				}
			},
			destroy(media) {
				var that = this
				swal.queue([{
					title: that.$t("messages.attention"),
					text: that.$t("messages.item_can_not_be_retrieved"),
					type: "warning",
					confirmButtonColor: "#53e69d",
					cancelButtonColor: "#ff7676",
					confirmButtonText: "Si",
					cancelButtonText: "No",
					showCancelButton: true,
					showLoaderOnConfirm: true,
					preConfirm: function () {
						that.loading = true
						return new Promise(function (resolve) {
							that.$http.delete(process.env.ROOT + '/api/' + that.$lang.getLang() + '/admin/media/' + media.id + '/destroy')
							.then(response => {
								that.reload()
								that.loading = false
								that.product.media.splice(that.product.media.indexOf(media), 1)
								swal({
									title: response.body.title,
									text: response.body.text,
									type: response.body.type
								})
							}).catch(function(response) {
								console.log(response)
								that.loading = false
							})
						})
					}
				}]).catch(swal.noop)
			},
			//
			dropzoneSuccess(response, file) {
				this.product.media.push(file)
				this.reload()
				this.initArray()
				this.renderImages()
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/management/productStorages/views/Images.vue